import React, { FC } from "react";

const columnName = [
  "<span></span>",
  "<span class='font-[700] text-[22px] text-violet_main'>ENTERPRISE</span>",
  "<span class='font-[700] text-[22px]'>ULTIMATE</span>",
];

const rowTitles = [
  "<span class='font-[500] text-[16px]'>Biaya Berlangganan dengan Pembayaran Tahunan</span><br/><span class='font-[300]'>(min 12 bulan)</span>",
  "<span class='font-[500] text-[16px]'>Biaya Berlangganan dengan Pembayaran Bulanan</span>",
  "<span class='font-[500] text-[16px]'>Jumlah Pengguna</span> <span class='font-[300]'>dari Satu Entitas Perusahaan, Instansi, atau Organisasi</span>",
  "<span class='font-[500] text-[16px]'>Jumlah Kursus dari Katalog Learnext</span><br/><span class='font-[300]'>(dari mitra Learnext dengan sertifikat resmi)</span>",
  "<span class='font-[500] text-[16px]'>Upload Video atau Konversi PPT Internal</span> <span class='font-[300]'>menjadi Kursus Digital dengan AI Learnext</span>",
  "<span class='font-[500] text-[16px]'>Total Durasi Diskusi Interaktif NEXA</span><br/><span class='font-[300]'>(berlaku untuk seluruh karyawan/anggota)</span>",
  "<span class='font-[500] text-[16px]'>Upload File Pengetahuan (Knowledge Base) Nexa</span><br/><span class='font-[300]'>(file dokumen, video, dan gambar)</span>",
  "<span class='font-[500] text-[16px]'>Data Dashboard Admin</span>",
];

const enterpriseContent = [
  "<span class='font-[700]'>IDR 50,000,000 per bulan</span><br/><span class='font-[300]'>(IDR 600,000,000 per tahun)</span>",
  "<span class='font-[500]'>IDR 63,000,000 per bulan</span>",
  "<span class='font-[700]'>TANPA BATAS<br/>(UNLIMITED LEARNERS)</span>",
  "<span class='font-[700]'>200 Kursus</span><br/><span class='font-[300]'>(Penggantian hingga 20 kursus per-bulan)</span>",
  "<span class='font-[300]'>Hingga total</span> <span class='font-[700]'>1.200 menit</span><br/><span class='font-[300]'>untuk 1 tahun</span>",
  "<span class='font-[700]'>24.000 menit</span><br/><span class='font-[300]'>untuk 1 tahun</span>",
  "<span class='font-[700]'>10GB</span>",
  "<span class='font-[700]'>Standar</span>",
];

const ultimateContent = [
  "<span class='font-[700]'>IDR 85,000,000 per bulan</span><br/><span class='font-[300]'>(IDR 1,020,000,000 per tahun)</span>",
  "<span class='font-[500]'>IDR 105,000,000 per bulan</span>",
  "<span class='font-[700]'>TANPA BATAS<br/>(UNLIMITED LEARNERS)</span>",
  "<span class='font-[700]'>SEMUA (1.000+) Kursus</span><br/><span class='font-[300]'>(Ditambah dan di-update otomatis tiap bulan)</span>",
  "<span class='font-[300]'>Hingga total</span> <span class='font-[700]'>6.000 menit</span><br/><span class='font-[300]'>untuk 1 tahun</span>",
  "<span class='font-[700]'>48.000 menit</span><br/><span class='font-[300]'>untuk 1 tahun</span>",
  "<span class='font-[700]'>20GB</span>",
  "<span class='font-[700]'>Dapat disesuaikan</span>",
];

type props = {
  width?: string;
};
const PricingTable: FC<props> = ({ width }) => {
  return (
    <div
      className={`grid grid-cols-[43.75%_28.125%_28.125%] gap-0 rounded-[12px] overflow-hidden border border-[#E5E7EB] bg-[#FFFFFF]`}
      style={{ width: width || "100%" }}
    >
      {/* Header */}
      {columnName.map((col, i) => (
        <div
          key={i}
          className={`px-[24px] py-[16px] ${
            i === 0
              ? "border-b border-[#E5E7EB]"
              : i === 1
              ? "border-l-[4px] border-r-[4px] border-t-[4px] border-b border-violet_main border-b-[#E5E7EB] flex items-center justify-center"
              : "border-b border-[#E5E7EB] flex items-center justify-center"
          }`}
          dangerouslySetInnerHTML={{ __html: col }}
        />
      ))}

      {/* Table Rows */}
      {rowTitles.map((title, i) => (
        <React.Fragment key={i}>
          <div
            className={`px-[24px] py-[16px] text-start ${
              i === rowTitles.length - 1 ? "" : "border-b"
            } border-[#E5E7EB]`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div
            className={`px-[24px] py-[16px] border-l-[4px] border-r-[4px] border-violet_main ${
              i === rowTitles.length - 1
                ? "border-b-[4px] border-b-violet_main"
                : "border-b border-b-[#E5E7EB]"
            } text-center`}
            dangerouslySetInnerHTML={{ __html: enterpriseContent[i] }}
          />
          <div
            className={`px-[24px] py-[16px] ${
              i === rowTitles.length - 1 ? "" : "border-b"
            } border-[#E5E7EB] text-center`}
            dangerouslySetInnerHTML={{ __html: ultimateContent[i] }}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default PricingTable;
